var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"assets-mapbox"},[_c('v-card',[_c('v-card-text',{ref:"container",staticStyle:{"height":"100%","width":"100%"}},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"map"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }